import Slider from "react-slick";
import "./style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ban1 from "../../images/slide/ban1.jpg";
import ban2 from "../../images/slide/ban2.jpg";
import ban3 from "../../images/slide/ban3.jpg";
import { useInView } from "framer-motion";
import { useRef } from "react";
import slugify from "../../Utils/slugify";

export default function SelctionSemaine() {
  const ref2 = useRef(null);
  const isInView2 = useInView(ref2, { once: true });

  const shouldEnableSlider = window.innerWidth < 700;

  const settings2 = {
    autoplay: false,
    autoplaySpeed: 2000,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div
      ref={ref2}
      style={{
        transform: isInView2 ? "none" : "translateY(200px)",
        opacity: isInView2 ? 1 : 0,
        transition: "all 0.9s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
      }}
    >
      {shouldEnableSlider && (
        <Slider {...settings2}>
          <div className="categorie">
            <div className="carousselDivHome">
              <div className="carouselDivH">
                <a
                  href={`/produit/${slugify(
                    "informatique & lifestyle"
                  )}/${slugify("lifestyle")}/${slugify(
                    "beaute & sante"
                  )}/${slugify("coiffure")}/${slugify(
                    "REMINGTON Keratin Protect Dryer"
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={ban1}
                    alt="weeklypromo"
                    className="banPromoPic"
                  />
                </a>

                <div className="carouselDivV">
                  <a
                    href={`/produit/${slugify(
                      "électroménager & cuisine"
                    )}/${slugify("cuisine")}/${slugify(
                      "preparation culinaire"
                    )}/${slugify(
                      "DECA HACHOIR 2L 300W KEMG011B"
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={ban2}
                      alt="weeklypromo"
                      className="banPromoPic2"
                    />
                  </a>

                  <a
                    href={`/produit/${slugify(
                      "informatique & lifestyle"
                    )}/${slugify("lifestyle")}/${slugify(
                      "beaute & sante"
                    )}/${slugify("coiffure")}/${slugify(
                      "MULTI STYLER 4 IN 1 UPDATED 3P"
                    )}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      src={ban3}
                      alt="weeklypromo"
                      className="banPromoPic2"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      )}

      {!shouldEnableSlider && (
        <div className="categorie">
          <div className="carousselDivHome">
            <div className="carouselDivH">
              <a
                href={`/produit/${slugify(
                  "informatique & lifestyle"
                )}/${slugify("lifestyle")}/${slugify(
                  "beaute & sante"
                )}/${slugify("coiffure")}/${slugify(
                  "REMINGTON Keratin Protect Dryer"
                )}`}
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={ban1}
                  alt="weeklypromo"
                  className="banPromoPic"
                />
              </a>

              <div className="carouselDivV">
                <a
                  href={`/produit/${slugify(
                    "électroménager & cuisine"
                  )}/${slugify("cuisine")}/${slugify(
                    "preparation culinaire"
                  )}/${slugify(
                    "DECA HACHOIR 2L 300W KEMG011B"
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={ban2}
                    alt="weeklypromo"
                    className="banPromoPic2"
                  />
                </a>

                <a
                  href={`/produit/${slugify(
                    "informatique & lifestyle"
                  )}/${slugify("lifestyle")}/${slugify(
                    "beaute & sante"
                  )}/${slugify("coiffure")}/${slugify(
                    "MULTI STYLER 4 IN 1 UPDATED 3P"
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={ban3}
                    alt="weeklypromo"
                    className="banPromoPic2"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}